export default {
  data() {
    return {
      irTop: [
        {
          path: "/ir/index",
          name: "IR情報トップ",
        },
      ],
      irMenus: [
        {
          path: "/ir/message",
          name: "株主・投資家の皆さまへ",
        },
        {
          path: "/ir/governance",
          name: "経営方針",
        },
        {
          path: "/ir/highlight",
          name: "業績ハイライト",
        },
        {
          path: "/ir/library",
          name: "IRライブラリー",
        },
        {
          path: "/ir/schedule",
          name: "IRカレンダー",
        },
        {
          path: "/ir/stock",
          name: "株式について",
        },
        {
          path: "/ir/faq",
          name: "よくあるご質問",
        },
        {
          path: "https://www.tabikobo.com/form/ir/",
          name: "IRお問い合わせ",
        },
        {
          path: "/ir/notice",
          name: "電子公告",
        },
        {
          path: "/ir/news",
          name: "IRニュース",
        },
        {
          path: "/ir/disclaimer",
          name: "免責事項",
        },
      ],
    };
  },
};
